<template>
  <div class="min-h-screen bg-slate-50">
    <!-- 스플래시 스크린 -->
    <SplashScreen @complete="onSplashComplete" />

    <!-- 메인 컨텐츠 -->
    <main class="main-content">
      <!-- 배너 섹션 -->
      <BannerSection />

      <!-- HOT 분양현장 -->
      <HotSection />

      <!-- 테마별 추천 현장 -->
      <CategorySection />

      <!-- 지역별 분양 현장 -->
      <LocationSection />

      <!-- 커뮤니티 -->
      <CommunitySection />

      <!-- 물개 매거진 -->
      <MagazineSection />
    </main>

    <!-- 푸터 -->
    <AppFooter />

    <!-- 팝업 광고 (스플래시 완료 후에만 표시) -->
    <PopupAd v-if="splashCompleted" />
  </div>
</template>

<script>
import { ref } from 'vue'
import BannerSection from '@/components/home/BannerSection.vue'
import HotSection from '@/components/home/HotSection.vue'
import CategorySection from '@/components/home/CategorySection.vue'
import LocationSection from '@/components/home/LocationSection.vue'
import CommunitySection from '@/components/home/CommunitySection.vue'
import MagazineSection from '@/components/home/MagazineSection.vue'
import PopupAd from '@/components/common/PopupAd.vue'
import SplashScreen from '@/components/common/SplashScreen.vue'
import AppFooter from '@/components/common/AppFooter.vue'

export default {
  name: 'HomeView',
  components: {
    BannerSection,
    HotSection,
    CategorySection,
    LocationSection,
    CommunitySection,
    MagazineSection,
    PopupAd,
    SplashScreen,
    AppFooter
  },
  setup() {
    const splashCompleted = ref(false)

    const onSplashComplete = () => {
      splashCompleted.value = true
    }

    return {
      splashCompleted,
      onSplashComplete
    }
  }
}
</script>

<style scoped>
@reference "tailwindcss";

.main-content {
  @apply pb-10;
}
</style>
